// Helpers for either/or/both checkbox groups in filter panes. Such a group must never end up
// empty: an empty selection would silently mean "search everything", which contradicts what the
// user sees. The default selection lives in utils/filterDefaults.ts (or personFilterStatuses.ts).
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// Toggles `value` in `selected`, but refuses to remove the last selected value - clicking the
// only checked checkbox is a no-op and returns the same array.
export var toggleRequiredSelection = function (selected, value) {
    if (!selected.includes(value))
        return __spreadArray(__spreadArray([], selected, true), [value], false);
    if (selected.length === 1)
        return selected;
    return selected.filter(function (v) { return v !== value; });
};
// True when both selections hold the same set of values (order-independent).
export var sameSelection = function (a, b) {
    return a.length === b.length && __spreadArray([], a, true).sort().join() === __spreadArray([], b, true).sort().join();
};
// Reads a multi-value filter from the URL. Without the param the group falls back to its
// default; an explicit param is respected as is.
export var selectionFromParams = function (params, key, defaults) { return (params.has(key) ? params.getAll(key) : defaults); };
// Writes a multi-value filter to the URL, omitting it when it equals the default so the default
// view keeps a clean URL (and selectionFromParams restores the default from its absence).
export var appendSelectionParams = function (params, key, selected, defaults) {
    if (sameSelection(selected, defaults))
        return;
    selected.forEach(function (value) { return params.append(key, value); });
};
